// Plans & Pricing (Manage Company). The public rate card is fetched outside
// redux by components/settings/ManageCompany/planCatalogClient.js — the
// landing page needs it before any store exists — so these actions cover the
// back-office screen only.
export const LOAD_PLAN_CATALOG = 'LOAD_PLAN_CATALOG';
export const STORE_PLAN_CATALOG = 'STORE_PLAN_CATALOG';
export const PLAN_CATALOG_LOADING = 'PLAN_CATALOG_LOADING';
export const PUBLISH_PLAN_CATALOG = 'PUBLISH_PLAN_CATALOG';
export const PREVIEW_PLAN_CATALOG = 'PREVIEW_PLAN_CATALOG';
export const STORE_PLAN_CATALOG_PREVIEW = 'STORE_PLAN_CATALOG_PREVIEW';
export const APPLY_PENDING_PLAN_CATALOG = 'APPLY_PENDING_PLAN_CATALOG';
export const SET_COMPANY_CUSTOM_RATE = 'SET_COMPANY_CUSTOM_RATE';
